// The header cell that sorts on click — the visible half of `lib/tableSort.ts`,
// used by `MasterTable` on References and by each hand-rolled `<Table>` on
// Rules (owner, 2026-09-01).
import { TableHeaderCell } from '@fluentui/react-components'
import type { CSSProperties } from 'react'

/** Everything else about the cell — its width, the small-caps class each screen
    applies — is passed straight through. */
export function SortableHeaderCell({
  children,
  sortDirection,
  onSort,
  className,
  style,
}: {
  /** The column's words — text only, because they are also its name. */
  children: string
  sortDirection: 'ascending' | 'descending' | undefined
  onSort: () => void
  className?: string
  style?: CSSProperties
}) {
  return (
    <TableHeaderCell
      sortable
      sortDirection={sortDirection}
      onClick={onSort}
      className={className}
      style={style}
      // Named explicitly (QA 2026-10-04, A-10), as the page tabs are (A-08):
      // the QA tool's accessibility reader showed the ID column's sort button
      // with no name, though its text is "ID".
      button={{ 'aria-label': children }}
    >
      {children}
    </TableHeaderCell>
  )
}
